import { MeteringType } from '@enums';
import { MeteringPointStub } from './metering-point-stub.model';

export class MeteringSubFilter {
  title: string;
  meteringType: MeteringType;
  excludedMeteringPoints: MeteringPointStub[];
  includedMeteringPoints: MeteringPointStub[];
  showTable: boolean;

  public static init = (title: string, type: MeteringType, includedMeteringPoints: MeteringPointStub[], showTable = false): MeteringSubFilter => {
    return <MeteringSubFilter>{
      title: title,
      meteringType: type,
      includedMeteringPoints: includedMeteringPoints,
      showTable: showTable
    };
  };
}
